import {
  DATASTRATEGY,
  IEntity,
  STORAGESTRATEGY,
} from '@proximus/entity-manager';
import { UserRight } from './model/user-right.model';

export const getIEntity: IEntity<UserRight[]> = {
  version: 'v1',
  url: '/rest/ur-buying/ordering-rights',
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: STORAGESTRATEGY.NONE,
  timeout: 30000,
};

export const updateIEntity: IEntity<any> = {
  version: 'v1',
  url: '/rest/ur-buying/ordering-rights',
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: STORAGESTRATEGY.NONE,
  timeout: 30000,
};
